<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item "><a routerLink="/admin/adminInvoice/">Invoices</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Invoice</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Invoice Details</h2>
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col-md-4 required">
                  <div class="form-group">
                    <label class="control-label" id="type">Customer Name</label>
                    <!-- <select id="type" class="form-control" [(ngModel)]="accountOwner"  [ngModelOptions]="{standalone: true}" required>
                         <option *ngFor="let a of accountOwners" [ngValue]="a.id">{{a.companyName}}</option>
                     </select>-->
                    <ng-select id="type" [(ngModel)]="accountOwner" (blur)="accountOwnerBlur()"
                               (change)="accountOwnerDetails();"
                               [ngModelOptions]="{standalone: true}" required
                               [items]="accountOwners"
                               bindLabel="companyName"
                               bindValue="id"
                               [searchFn]="customSearchAccountOwner"
                               [ngClass]="{'is-invalid':statusText1}"
                               [ngClass]="{'service-error':statusText1}"
                               [searchWhileComposing]="true">
                      <ng-template ng-option-tmp let-item="item">
                        {{item?.ownerName}} <br/>
                        <small>{{item?.companyName}}</small>
                      </ng-template>
                    </ng-select>
                    <div id="statusText1" class="invalid-feedback d-block mb-3"
                         [hidden]="!statusText1">{{statusText1}}</div>
                  </div>
                </div>

                <!--
                                <div class="col-md-3">
                                  <div class="form-group">
                                    <label class="control-label">Invoice Number</label>
                                    <input type="text" id="invoiceNumber" [(ngModel)]="invoiceNumber"
                                           [ngModelOptions]="{standalone: true}" class="form-control">
                                  </div>
                                  <div id="statusText2" class="invalid-feedback d-block mb-3"
                                       [hidden]="!statusText2">{{statusText2}}</div>
                                </div>
                -->

                <div class="col-md-4 required">
                  <div class="form-group">
                    <label class="control-label">Invoice Date</label>
                    <input type="date" id="InvoiceDate" [(ngModel)]="invoiceDate" [ngModelOptions]="{standalone: true}"
                           class="form-control" [ngClass]="{'is-invalid':statusText3}" (blur)="dateBlur()" required>
                    <div id="statusText3" class="invalid-feedback d-block mb-3"
                         [hidden]="!statusText3">{{statusText3}}</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">Reference Number</label>
                    <input type="text" id="referenceNumber" [(ngModel)]="referenceNumber"
                           [ngModelOptions]="{standalone: true}"
                           class="form-control">
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label">Period</label>
                    <input type="text" id="Period" [(ngModel)]="period" [ngModelOptions]="{standalone: true}"
                           class="form-control">
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Line Details</h2>
          <table class="table">
            <thead>
            <tr>
              <th style="width:200px">Item</th>
              <th style="width:150px">Cost</th>
              <th style="width:150px">Quantity</th>
              <th style="width:50px">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let i of itemLines;let j = index;">
              <td>{{i.itemCode}}</td>
              <td>{{i.invoiceAmount}}</td>
              <td>{{i.quantity}}</td>
              <td>
                <a (click)=removeItem(i) data-toggle="modal" data-target="#deleteEntryModal">
                  <svg xmlns="http://www.w3.org/2000/svg" height="21" viewBox="0 0 18.877 24.27">
                    <defs>
                      <style>.a {
                        fill: #848484;
                      }</style>
                    </defs>
                    <path class="a"
                          d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                          transform="translate(-7.5 -4.5)"/>
                  </svg>
                </a>
              </td>
            </tr>
            <tr>
              <td>
                <ng-select id="warehouseName" [(ngModel)]="item" [ngModelOptions]="{standalone: true}" required
                           [items]="items"
                           bindLabel="config"
                           [ngClass]="{'is-invalid':statusText4}" [ngClass]="{'service-error':statusText4}"
                           placeholder="Item" required>
                  <ng-template ng-header-tmp>
                    <div>
                      <button class="btn btn-outline-primary btn-sm" (click)="openItemModal()">
                        <svg class="bi bi-plus mr-2" width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd"
                                d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"></path>
                          <path fill-rule="evenodd"
                                d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"></path>
                        </svg>
                        Add New Item
                      </button>
                    </div>
                  </ng-template>
                </ng-select>
              </td>
              <td>
                <input type="text" id="amount" [(ngModel)]="invoiceAmount" appOnlyNumbers class="form-control"
                       [ngModelOptions]="{standalone: true}" class="form-control" [ngClass]="{'is-invalid':statusText5}"
                       required>
              </td>
              <td>
                <input type="text" id="quantity" [(ngModel)]="quantity" appOnlyNumbers class="form-control"
                       [ngModelOptions]="{standalone: true}" class="form-control"
                       [ngClass]="{'is-invalid':quantityError}" required>
              </td>
              <td>
                <a (click)="addSelectedItem()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21.34 21.34">
                    <defs>
                      <style>.ab {
                        fill: #ee7125;
                      }</style>
                    </defs>
                    <path class="ab"
                          d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                          transform="translate(-3.375 -3.375)"/>
                  </svg>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="offset-8 col-3">
              <div class="row py-1">
                <div class="col-8 text-right"><b>Sub Total :</b></div>
                <div class="col-4 text-right">{{this.subTotal}}</div>
              </div>
              <div class="row py-1"
                   *ngIf="(this.gstNumberCorp !== null && this.gstNumberCorp !== '36' ) || (this.gstNumberCorp == null && this.addressState !== 'telangana')">
                <div class="col-8 text-right"><b>IGST (18%) :</b></div>
                <div class="col-4 text-right">{{this.igstTotal}}</div>
              </div>
              <div class="row py-1"
                   *ngIf="(this.gstNumberCorp !== null && this.gstNumberCorp == '36' ) || (this.gstNumberCorp == null && this.addressState === 'telangana')">
                <div class="col-8 text-right"><b>CGST (9%) :</b></div>
                <div class="col-4 text-right">{{this.cgstTotal}}</div>
              </div>
              <div class="row py-1"
                   *ngIf="(this.gstNumberCorp !== null && this.gstNumberCorp == '36' ) || (this.gstNumberCorp == null && this.addressState === 'telangana')">
                <div class="col-8 text-right"><b>SGST (9%) :</b></div>
                <div class="col-4 text-right">{{this.sgstTotal}}</div>
              </div>
              <div class="row border-top py-1">
                <div class="col-8 text-right"><b>Total :</b></div>
                <div class="col-4 text-right">{{this.total}}</div>
              </div>

            </div>
          </div>
          <div id="statusText4" class="invalid-feedback d-block mb-3"
               [hidden]="!statusText4">{{statusText4}}</div>
          <div id="statusText5" class="invalid-feedback d-block mb-3"
               [hidden]="!statusText5">{{statusText5}}</div>
          <div id="quantityError" class="invalid-feedback d-block mb-3"
               [hidden]="!quantityError">{{quantityError}}</div>
          <div id="itemLinesError" class="invalid-feedback d-block mb-3"
               [hidden]="!itemLinesError">{{itemLinesError}}</div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" class="btn btn-cancel-prime" routerLink="/admin/adminInvoice">Cancel</button>
      <button type="submit" class="btn btn-orange-prime ml-2" (click)="submitItem()">Save</button>
    </div>
  </div>
</div>

<div class="container">
  <div class="modal fade" id="deletEntryModal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Delete</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <p>Do you really want to delete </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" data-dismiss="modal">No</button>
          <button type="button" class="btn btn-edit" data-dismiss="modal">Yes</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="addItemContainer">
  <div [ngStyle]="{'display': addItemModalOpen == true? 'block' : 'none'}" style="overflow-y:auto"
       [ngClass]="{'modal': addItemModalOpen == true}" class="modal" id="popUpAssign" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <!--  <div class="modal fade" id="addItemModal" role="dialog"
           [ngStyle]="{'display': addItemModalOpen ? 'block' : 'none', 'opacity': 1}">-->
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">New Item</h4>
          <button type="button" class="close" (click)="closeModal()">&times;</button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="control-label">Item</label>
                <input type="text" id="itemType" [(ngModel)]="itemType" [ngModelOptions]="{standalone: true}"
                       class="form-control">
              </div>
              <div id="itemTypeError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!itemTypeError">{{itemTypeError}}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-delete" (click)="closeModal()">Cancel</button>
          <button type="button" class="btn btn-edit" (click)="addLineItem()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>
